RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _, moment, adminEditingProperties) {

    'use strict';

    views.Account = Marionette.ItemView.extend({
        template: '#adminAccountDetailsKnownAccountTemplate',

        ui: {
            edit: '.x-edit',
            expander: '.x-panel-expander',
            facebookConnections: '.x-facebook-connections',
            instagramConnections: '.x-instagram-connections'
        },

        events: {
            'click @ui.edit': 'edit',
            'click @ui.expander': 'onExpanderClick',
            'click @ui.facebookConnections': 'onFacebookConnectionsClick',
            'click @ui.instagramConnections': 'onInstagramConnectionsClick'
        },

        onExpanderClick: function (e) {
            const target = $(e.currentTarget);
            target.toggleClass('fa-chevron-down fa-chevron-right');
            target.closest('.panel').find('.panel-body').toggle();
        },

        onFacebookConnectionsClick: function () {
            const me = this;
            me.onConnectionsClick(RivalIQ.enums.sources.FACEBOOK);
        },

        onInstagramConnectionsClick: function () {
            const me = this;
            me.onConnectionsClick(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS);
        },

        onConnectionsClick: function (source) {
            const me = this;

            me.model.set('source', source);
            me.model.set('adminModeAccountId', me.model.get('account_id'));

            RivalIQ.execute('show:modal', new RivalIQ.apps.AccountSettings.views.ConnectedPagesModal(
                {
                    model: me.model
                }
            ));

        },

        templateHelpers: function () {
            const me = this;

            return {
                plan: me.accountDetails.plan,
                conversionStatus: _.upperFirst(_.camelCase(_.invert(RivalIQ.enums.account.conversionStatus)[me.accountDetails.user.account.account_conversion_status_id])),
                mrr: _.get(me.accountDetails.user.account.salesforce_data, ['MRR__c'], ''),
                didOnboardingCall: _.get(me.accountDetails.user.account.salesforce_data, ['Participated_in_onboarding_call__c'], ''),
                intercomAppId: me.intercomAppId,
                landscapesCount: me.accountDetails.dbLandscapesCount,
                landscapes: me.accountDetails.dbLandscapesPanel,
                followedCompaniesCount: me.accountDetails.followedCompaniesCount,
                activeUserCount: _.filter(me.accountDetails.accountUsers, {
                    status: 'active'
                }).length,
                daysActiveLast30: _.get(me.accountDetails.user.account.usage_scores, 'last_30_days'),
                daysActivePrior30: _.get(me.accountDetails.user.account.usage_scores, 'prior_30_days'),
                allAccountTokens: me.accountDetails.allAccountTokens,
                unpackGranularScopes: function unpackGranularScopes(scopes) {
                    if (!scopes) {
                        return '';
                    }
                    const appliesToAllPages = [];
                    const appliesToLimitedPages = [];
                    for (const item of scopes) {
                        item.target_ids ? appliesToLimitedPages.push(`${item.scope}: ${item.target_ids.join(', ')}`) : appliesToAllPages.push(item.scope);
                    }

                    return `Applies To All Pages: ${appliesToAllPages.join(', ') || 'none'}.\n
                        Applies Only to Listed Pages: ${appliesToLimitedPages.join(';\n') || 'none'}.`;
                },
                facebookTokenHistory: me.accountDetails.facebookTokenHistory,
                facebookAdAccountsInfo: me.accountDetails.facebookAdAccountsInfo
            };
        },

        behaviors: {
            ImpersonateAction: {
                behaviorClass: RivalIQ.apps.Admin.behaviors.ImpersonateAction
            }
        },

        getOwnerId: function () {
            return (RivalIQ.state.account.isImpersonated() ?
                RivalIQ.state.user.get('impersonatorId') : RivalIQ.state.user.get('id'));
        },

        getAccountStatus: function () {
            const me = this;
            return me.model.get('account_status_id');
        },

        getAccountUserStatus: function () {
            const me = this;
            return me.accountDetails.user.account_user_status_id;
        },

        getImpersonationEmail: function () {
            const me = this;
            return me.model.get('email');
        },

        edit: function () {
            const me = this;

            RivalIQ.execute('show:modal', new views.Edit({
                model: new RivalIQ.apps.Admin.models.User(me.accountDetails.user),
                selectorProperties: adminEditingProperties,
                refreshAfterSave: true
            }));
        },

        initialize: function (options) {
            const me = this;
            const opts = _.pick(options, 'intercomAppId', 'accountDetails');
            _.extend(me, opts);

            // NOTE hide the nav (although we do want the shell alert handlers, etc. to be present)
            $('body').addClass('no-ui');
            $('#secondary-nav').hide();
        }
    });
}, window.moment, window.adminEditingProperties);
